import axios from 'axios';
import { AppUrls, } from './Globals';
import { Config } from './Config';

export const roleRequests = {}

roleRequests.GetRoles = (data) => {
  return axios.post(
    AppUrls.GetRoles,
    Config.SetParameters(data, '', '', ''),
    Config.ConfigAuth()
  ).then(handleResponse)
}

roleRequests.GetTenats = (data) => {
  return axios.post(
    AppUrls.GetTenats,
    Config.SetParameters(data, '', '', ''),
    Config.ConfigAuth()
  ).then(handleResponse)
}

let handleResponse = (response) => {
  let respObject = response.data;//BodySecurityResponse(response.data);
  if (!respObject.IsOK) {
    let responseObject = { message: respObject.Messages + ' ' + (respObject.TansactionId ? respObject.TansactionId : '') + ' ' + (respObject.statusText ? respObject.statusText : '') };
    let error = (respObject.Body || responseObject);
    return Promise.reject(error);
  }
  return respObject;
}